<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="基地" prop="cooperativeBaseId">
          <a-select v-model="form.cooperativeBaseId">
            <a-select-option
              v-for="item in list"
              :key="item"
              :value="item.id"
              >{{ item.baseName }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="活动年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="活动主题" prop="subject">
          <a-input v-model="form.subject"  placeholder="请输入活动主题"/>
        </a-form-model-item>
        <a-form-model-item label="参与人数" prop="peopleNum">
          <a-input-number
            v-model="form.peopleNum"
            min="1"
            precision="0"
            @blur="blurValue"
          />
        </a-form-model-item>
          <a-form-model-item label="地点" prop="address">
          <a-input v-model="form.address"  placeholder="请输入地点"/>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        cooperativeBaseId: "",
        acquireYear: "",
        peopleNum: "",
        subject:'',
        address:'',
      },
      rules: {
        cooperativeBaseId: [
          {
            required: true,
            message: "请选择基地",
            trigger: "change",
          },
        ],
        acquireYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireYear!='') {
                callback(); // 验证通过
              } else {
                callback(new Error('请选择年份'));
              }
            },
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
         subject: [
          {
            required: true,
            message: "请输入活动主题",
            trigger: "blur",
          },
        ],
        peopleNum: [
          {
            required: true,
            message: "请输入参与人数",
            trigger: "blur",
          },
        ],
          address: [
          {
            required: true,
            message: "请输入地点",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      list: [],
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
    // this.getList();
  },
  methods: {
    getList(id) {
      getAction("/lxbase/lxApplyCooperativeBase/getList",{applyId:id}).then((res) => {
        this.list = res.result;
      });
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleChange() {
      // console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    handleClearAcquireYear(val) {
      this.form.acquireYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      // this.form.acquireYear = value;
      const year = moment(value).format('YYYY');
      this.form.acquireYear =year+"";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("acquireYear");
      // this.yearShowOne = false;
    },
    init(type, record) {
      this.type = type;
      this.visible = true;
      // this.getxwlist();
      // this.getcgjb();
      // this.getkclist();
      this.getList(record.id);
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.title = "新增活动";
        this.form.acquireYear=new Date().getFullYear()+"";
      } else {
        this.title = "编辑活动";
        this.form = {
          title: record.title,
          achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          subject:record.subject,
          address:record.address,
        };
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }
        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      this.jblist = [
        {
          value: "国家级",
          title: "国家级",
        },
        {
          value: "省级",
          title: "省级",
        },
        {
          value: "市级",
          title: "市级",
        },
        {
          value: "县级",
          title: "县级",
        },
        {
          value: "校级",
          title: "校级",
        },
        {
          value: "其他",
          title: "其他",
        },
      ];
      // getAction("/baseCommon/getDictItemsByCode?code=achievement_level",).then((res) => {
      // 	if (res.code == 200) {
      // 		this.jblist=res.result;
      // 	}
      // });
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != "" &&
        this.type == "add"
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            postAction("/lx/lxPracticeBase/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let params = this.form;
            if (typeof this.form.acquireYear == "object") {
              params.acquireYear =
                new Date(this.form.acquireYear).getFullYear() + "";
            }
            params.applyType = this.applyType;
            putAction("/lx/lxTeamBuilding/edit", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("编辑成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
  